export default __webpack_public_path__ + "static/media/digiSMT.35bacfb6.svg";